import api from "./Api";

class PedidoItemDetMetragemService {
  GetPedidoItemDetMetragem(payload) {
    return api.get("/v1/pedidoItemDetMetragem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoItemDetMetragem(payload) {
    return api.post("/v1/pedidoItemDetMetragem/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoItemDetMetragem(payload) {
    return api.put("/v1/pedidoItemDetMetragem/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoItemDetMetragem(payload) {
    return api
      .delete("/v1/pedidoItemDetMetragem/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetPedidoItemDetMetragemOData(payload) {
    return api
      .get("/OData/PedidoItemDetMetragem" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new PedidoItemDetMetragemService();
